import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getProvinces = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.provinces
);

export const getProvincesLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.provincesLoading
);

export const getProvincesError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.provincesError
);

export const getBuildings = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.buildings
);

export const getBuildingsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.buildingsLoading
);

export const getBuildingsError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.buildingsError
);

export const getOrganizations = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.organizations
);

export const getOrganizationsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.organizationsLoading
);

export const getOrganizationsError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.organizationsError
);

export const getLocations = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.locations
);

export const getLocationsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.locationsLoading
);

export const getLocationsError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.locationsError
);

export const getValidities = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.validities
);

export const getValiditiesLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.validitiesLoading
);

export const getValiditiesError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.validitiesError
);

export const getSalesReps = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.salesReps
);

export const getSalesRepsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.salesRepsLoading
);

export const getSalesRepsError = createSelector(
  getKwikspaceAppState,
  (state) => state.kwikspace.salesRepsError
);